import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';
import { CATEGORY_NAMES, categoryOf, occasionsOf } from '@/lib/studioLinks';

let request = null;
// Public catalogue + occasions for the website; fetched once per page load.
export const useCatalog = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    request ||= Promise.all([studioApi('/products'), studioApi('/occasions').catch(() => ({ items: [] }))]).then(([p, o]) => ({ products: p.products || [], occasions: o.items || [] })).catch(() => { request = null; return { products: [], occasions: [] }; });
    request.then(setData);
  }, []);
  return data;
};

export const MATERIAL_ORDER = ['holz', 'textil', 'glas', 'schiefer', 'metall', 'kunststoff'];
export const materialsOf = products => MATERIAL_ORDER.map(id => ({ id, name: CATEGORY_NAMES[id], products: products.filter(p => categoryOf(p) === id) })).filter(m => m.products.length);
export const occasionsWith = (occasions, products) => occasions.map(o => ({ ...o, products: products.filter(p => occasionsOf(p).includes(o.id)) })).filter(o => o.products.length);
export const fromPrice = list => Math.min(...list.map(p => p.price_cents));
// One showcase article per material for the live preview.
export const showcase = (products, limit = 3) => MATERIAL_ORDER.map(id => products.find(p => categoryOf(p) === id)).filter(Boolean).slice(0, limit);

export const useSeo = (title, description) => {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
    meta.content = description;
  }, [title, description]);
};

let storefrontRequest = null;
// Admin-maintained social proof; empty values hide the related UI.
export const useStorefront = () => {
  const [data, setData] = useState(null);
  useEffect(() => { storefrontRequest ||= studioApi('/storefront').catch(() => { storefrontRequest = null; return null; }); storefrontRequest.then(setData); }, []);
  return data;
};
export const ratingFor = (storefront, productId) => storefront?.product_ratings?.find(r => r.product_id === productId && r.count > 0) || null;

const MOODS = ['holz', 'textil', 'glas', 'metall', 'schiefer', 'kunststoff'];
const OCCASION_MOODS = ['hochzeit', 'geburtstag', 'gedenken', 'verein', 'jga', 'firma', 'geschenk'];
export const materialImage = m => MOODS.includes(m.id) ? `/images/platform/mat-${m.id}.webp` : m.products[0]?.image;
export const occasionImage = o => o.image || (OCCASION_MOODS.includes(o.id) ? `/images/platform/occ-${o.id}.webp` : o.products[0]?.image);
export const MATERIAL_HINTS = { holz: 'Bretter, Scheiben, Schilder', textil: 'T-Shirts & Teamkleidung', glas: 'Schilder & Gläser', metall: 'Anhänger & Marken', schiefer: 'Platten & Untersetzer', kunststoff: 'Schilder & Kennzeichnung' };
